module.exports = __webpack_public_path__ + "static/ba04a9e3-2d03-44bf-9de0-b8a191a6de4d-065d75aef1e6cd8db92c0088e23f93eb.webp";